module.exports = __webpack_public_path__ + "static/media/tiktok.1f9730dc.jpg";